<template>
  <header class="bg-white border-bottom shadow-sm overflow-hidden" style="contain: inline-size">
    <b-container fluid class="d-flex align-items-start py-2 px-3 px-md-4" style="min-width: 0">
      <b-button
        :to="backLink.to"
        variant="outline-secondary"
        size="sm"
        class="d-flex align-items-center justify-content-center flex-shrink-0 p-0 mr-3"
        style="width: 28px; height: 28px; border-color: #e2e8f0; color: #163D7D"
        :title="`Volver a ${backLink.label}`"
        :aria-label="`Volver a ${backLink.label}`"
      >
        <font-awesome-icon :icon="['far', 'chevron-left']" />
      </b-button>

      <div class="flex-grow-1" style="min-width: 0">
        <div class="d-flex align-items-center fs-15 text-muted mb-1" style="min-width: 0">
          <span class="font-weight-bold flex-shrink-0" style="color: #163D7D">{{ drawingRequest.request_no }}</span>
          <span class="flex-shrink-0 mx-2" style="color: #c7d0dc">/</span>

          <b-link
            :to="clientPath"
            class="text-truncate text-dark font-weight-bold fs-15"
            style="min-width: 0; flex: 1 1 auto"
            :title="clientName"
          >
            {{ clientName }}
          </b-link>

          <b-link
            :to="projectPath"
            class="d-inline-flex align-items-center justify-content-center justify-content-lg-start rounded font-weight-bold px-lg-2"
            style="height: 24px; min-width: 24px; max-width: 30%; flex: 0 4 auto; color: #163D7D; background: #e7edf7"
            :title="`Ir al proyecto: ${drawingRequest.project.name}`"
            :aria-label="`Ir al proyecto: ${drawingRequest.project.name}`"
          >
            <font-awesome-icon :icon="['far', 'briefcase']" class="flex-shrink-0 fs-17" />
            <span class="d-none d-lg-inline text-truncate ml-1 fs-15" style="min-width: 0">
              {{ drawingRequest.project.name }}
            </span>
          </b-link>
        </div>

        <h1
          class="font-weight-bold text-clamp-2 mb-0"
          :title="drawingRequest.title"
          style="color: #163D7D; font-size: 1.125rem; line-height: 1.25"
        >
          {{ drawingRequest.title }}
        </h1>
      </div>
    </b-container>
  </header>
</template>

<script>
export default {
  name: 'DrawingRequestShowHeader',
  props: {
    drawingRequest: { type: Object, required: true },
    backLink: { type: Object, required: true }
  },
  computed: {
    projectPath () {
      return `/app/prod/proyectos/${this.drawingRequest.project.id}`
    },
    clientPath () {
      const clientId = this.drawingRequest.project.client_id
      return clientId ? `/app/prod/clientes/${clientId}` : null
    },
    clientName () {
      const { client_name, client_num } = this.drawingRequest
      if (!client_name) return 'Sin cliente'
      return client_num ? `${client_num} - ${client_name}` : client_name
    }
  }
}
</script>
